export default __webpack_public_path__ + "fea2e4bce207f324bbb0c8d12f1c2bc3.png";